<template>
  <v-dialog v-model="newVersionDialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn class="action-btn mr-2" color="success" v-on="on">
        <v-icon class="mr-2">mdi-plus</v-icon>
        Dodaj
      </v-btn>
    </template>
    <v-card>
      <v-form @submit.prevent="newVersion">
        <v-card-title>
          <span class="headline">Tworzenie nowego szkolenia</span>
        </v-card-title>
        <v-card-text class="mt-4">
          <v-text-field
            v-model="form.name"
            autofocus
            label="Nazwa szkolenia"
            name="name"
            type="text"
            :error-messages="nameErrors"
            @input="$v.form.name.$touch()"
            @blur="$v.form.name.$touch()"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" class="text--secondary" text :disabled="saving" @click="newVersionDialog = false"
            >Anuluj</v-btn
          >
          <v-btn type="submit" color="primary" text :loading="saving">Dodaj</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import CourseServiceApi from '@/api/courseServiceApi';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  mixins: [validationMixin],
  data: function() {
    return {
      newVersionDialog: false,
      saving: false,
      form: {
        name: null
      }
    };
  },
  computed: {
    ...mapAccountState(['token']),
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) {
        return errors;
      }
      if (!this.$v.form.name.required) {
        errors.push('Nazwa szkolenia jest wymagana');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    async newVersion() {
      this.$v.$touch();

      if (this.formValid) {
        try {
          this.saving = true;
          const response = await new CourseServiceApi(this.token).create({
            name: this.form.name
          });

          this.newVersionDialog = false;
          this.$router.push({
            path: `/manage/courses/edit/${response.data.result}`
          });
        } catch (e) {
          // TODO: handle
          console.error(e);
        } finally {
          this.saving = false;
        }
      }
    }
  }
};
</script>
